import React from 'react'
import { Layout } from 'antd'
import Header from './header'

const AppLayout = (props) => {
  return (
    <Layout className="app-layout">
      <Header />
      <Layout>
        <Layout.Content className='content-wrapper'>{props.children}</Layout.Content>
      </Layout>
    </Layout>
  )
}

const BasicLayout = (props) => {
  return (
    <Layout className="basic-layout">
      <Header />
      <Layout.Content className='content-wrapper'>{props.children}</Layout.Content>
    </Layout>
  )
}

export { AppLayout, BasicLayout }
